import { cn } from "@/lib/utils"

export const Card = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode
} & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div className={cn("border border-gray-200 rounded-lg p-5", className)} {...props}>
      {children}
    </div>
  )
}
